var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0852 8.04086C11.3049 8.26054 11.3049 8.61731 11.0852 8.837L7.71084 12.2113C7.49115 12.431 7.13439 12.431 6.9147 12.2113C6.69502 11.9917 6.69502 11.6349 6.9147 11.4152L9.89185 8.43805L6.91646 5.4609C6.69678 5.24121 6.69678 4.88445 6.91646 4.66476C7.13614 4.44508 7.49291 4.44508 7.71259 4.66476L11.0869 8.0391L11.0852 8.04086Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSolid);
export default __webpack_public_path__ + "static/media/chevron-right-solid.2ec4a6db0fc75f7659786db4a0ed0e93.svg";
export { ForwardRef as ReactComponent };